import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ChangeDetectorRef } from '@angular/core';
import { NgxSpinnerService } from "ngx-spinner";
import { catchError, forkJoin, lastValueFrom, Observable, of } from 'rxjs';
import { CentrosMantencionService } from '../../../../services/centralization/centros-mantencion.service';
import { UsuariosService } from '../../../../services/centralization/usuarios.service';
import { map, startWith } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { AutoCompleteModule } from 'primeng/autocomplete';


@Component({
  selector: 'app-crear-nuevo-centro',
  templateUrl: './crear-nuevo-centro.component.html',
  styleUrls: ['./crear-nuevo-centro.component.css'],
    standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AutoCompleteModule
  ],
})
export class CrearNuevoCentroComponent {
  @Output() centroAgregado = new EventEmitter<any>();
  @Input() sociedades: any[] = [];

  nuevoCentroForm: FormGroup;
  switchLabel: string = 'Activado'; 
  mensajeError: string = '';
  mensajeErrorCodigo: string = '';
  mensajeErrorNombre: string = '';
  selectedAnalistaId: number | null = null; 
  selectedItem: any; 
  suggestions: any[] = []; 
  noAnalistaFound: boolean = false;
  bloquearSegmento = true;
  sociedad: any[] = []; 
  segmentos: any[] = [];
  sociedadSeleccionada: any = null;
  


  constructor(
    private readonly _formBuilder: FormBuilder,
    public activeModal: NgbActiveModal,
    private readonly _centrosService: CentrosMantencionService,
    private readonly _toastr: ToastrService,
    private readonly _cdr: ChangeDetectorRef,
    private readonly _spinner: NgxSpinnerService,
    private readonly _usuarioService: UsuariosService,
    
  ) {
    this.nuevoCentroForm = this._formBuilder.group({
      centCodigoCompania: ['', [Validators.required]],
      centNombreCentro: ['', [Validators.required]],
      centAnalistaFinanzas: ['', [Validators.required]],
      centSegmento: ['', [Validators.required]],
      //centCentroCosto: ['', [Validators.required]],
      centSociedad: ['', [Validators.required]],
      centActivado: [true],
      centIniciales: ['', [Validators.required]],
    });
  }
  ngOnInit(): void {
    this.nuevoCentroForm.get('centCodigoCompania')?.valueChanges.subscribe(() => {
      this.mensajeErrorCodigo = '';
    });
    this.nuevoCentroForm.get('centNombreCentro')?.valueChanges.subscribe(() => {
      this.mensajeErrorNombre = '';
    });
    
    this.nuevoCentroForm.controls['centSegmento'].disable();
    this.obtenerSociedadesYSegmentos();
  }

  search(event: any): void {
    const query = event.query;
    this._usuarioService.listarUsuariosAnalistas(query)
      .pipe(
        map((usuarios: any[]) => usuarios.filter(usuario =>
          usuario.us_nombres.toLowerCase().includes(query.toLowerCase())
        )),
        catchError(error => {
          console.error('Error al cargar los usuarios:', error);
          return [];
        })
      )
      .subscribe(filteredUsers => {
        this.suggestions = filteredUsers; 
        this.noAnalistaFound = this.suggestions.length === 0;
        this.selectedItem = null;
      });
  }
  onAnalistaSelect(event: any) {
    console.log('event',event)
    
    // Guarda el analista seleccionado y actualiza el formulario
    this.selectedItem = event;
    console.log('seleccion,',this.selectedItem.value.us_nombres)
    this.nuevoCentroForm.get('centAnalistaFinanzas')?.setValue(event.value);
    this.noAnalistaFound = false;
  }



  async onSubmit() {
    this._cdr.detectChanges();
    console.log('Enviando datos al servicio...', this.nuevoCentroForm.value);
    if (this.nuevoCentroForm.invalid) {
      this.nuevoCentroForm.markAllAsTouched(); 
      this._toastr.warning('Por favor, completa todos los campos requeridos.', 'Advertencia');
      return;
    }
    if (!this.selectedItem) {
      this._toastr.warning('Por favor, selecciona un analista válido.', 'Advertencia');
      return;
    }
    if (this.nuevoCentroForm.valid) {
      const analistaFinanzas = this.nuevoCentroForm.get('centAnalistaFinanzas')?.value;
      const centSociedad = this.nuevoCentroForm.get('centSociedad')?.value;
      console.log('analista seleccionado ',analistaFinanzas)
      console.log('centSociedad ',centSociedad)
      const nuevoCentro = {
        centCodigoCompania: this.nuevoCentroForm.get('centCodigoCompania')?.value,
        centNombreCentro: this.nuevoCentroForm.get('centNombreCentro')?.value,
        centSegmento: this.nuevoCentroForm.get('centSegmento')?.value,
        centCentroCosto: this.nuevoCentroForm.get('centCentroCosto')?.value,
        centAnalistaFinanzas: analistaFinanzas ? analistaFinanzas.us_nombres : null,
        centSociedad: centSociedad.socSociedad,
        centActivado: this.nuevoCentroForm.get('centActivado')?.value ? 1 : 0, 
        usId: analistaFinanzas ? analistaFinanzas.us_id : null,
        socId: centSociedad.socId,
        centIniciales :this.nuevoCentroForm.get('centIniciales')?.value,
      };
      console.log('Datos convertidos:', nuevoCentro);
      this._spinner.show();
      try {
        const resultado = await this.verificarExistencia(
          nuevoCentro.centCodigoCompania, 
          nuevoCentro.centNombreCentro
        );
        if (resultado.existeCodigo && resultado.existeNombre) {
          this.mensajeErrorNombre = 'El nombre ingresado ya existe en Mantenedor de centro.';
          this.mensajeErrorCodigo = 'El ID ingresado ya existe en Mantenedor de centro.';
          this._toastr.error('El ID y el nombre del centro ya existen.', 'Error');
        } else if (resultado.existeCodigo) {
          this.mensajeErrorCodigo = 'El ID ingresado ya existe en Mantenedor de centro.';
          this._toastr.error('El ID ingresado ya existe en Mantenedor de centro.', 'Error');
        } else if (resultado.existeNombre) {
          this.mensajeErrorNombre = 'El nombre ingresado ya existe en Mantenedor de centro.';
          this._toastr.error('El nombre ingresado ya existe en Mantenedor de centro.', 'Error');
        } else {
          this.activeModal.close(nuevoCentro);
        }
      } catch (error) {
        this._toastr.warning('Hubo un error durante la verificación.', 'Error');
        console.error('Error durante la verificación:', error);
      } finally {
        this._spinner.hide();
      }
    } else {
      this._toastr.warning('Por favor, completa todos los campos requeridos.', 'Advertencia');
    }
    
  }
  
  
  async verificarExistencia(codigo: string, nombre: string): Promise<{ existeCodigo: boolean; existeNombre: boolean }> {
    try {
      const result = await lastValueFrom(
        forkJoin({
          existeCodigo: this._centrosService.obtenerCentroPorCodigo(codigo),
          existeNombre: this._centrosService.obtenerCentroPorNombre(nombre)
        }).pipe(
          catchError((error) => {
            console.error('Error al verificar existencia:', error);
            this._spinner.hide();
            throw error;
          })
        )
      );
  
      return result;
    } catch (error) {
      console.error('Error general:', error);
      throw error;
    }
  }
 verificarExistenciaCampo(controlName: string) {
    try {
      const valor = this.nuevoCentroForm.get(controlName)?.value;
      if (!valor) return;
      if (controlName === 'centCodigoCompania') {
        this._spinner.show();
        this._centrosService.obtenerCentroPorCodigo(valor).subscribe({
          next:(existeCodigo) => {
            this.mensajeErrorCodigo = existeCodigo 
              ? 'El ID ingresado ya existe en Mantenedor de centro.' 
              : '';
            this._cdr.detectChanges(); 
            this._spinner.hide();
          },
          error:(error) => {
            console.error('Error al verificar el código:', error);
            this._spinner.hide();
          }
        }) 
      }
      if (controlName === 'centNombreCentro') {
        this._spinner.show();
        this._centrosService.obtenerCentroPorNombre(valor).subscribe({ 
          next:(existeNombre) => {
            this.mensajeErrorNombre = existeNombre 
              ? 'El nombre ingresado ya existe en Mantenedor de centro.' 
              : '';
            this._cdr.detectChanges(); 
            this._spinner.hide();
          },
          error:(error) => {
            console.error('Error al verificar el nombre:', error);
            this._spinner.hide();
          }

        })
          
      }
      
    } catch (error) {
      console.error('Error al verificar la existencia:', error);
    }
  }
  onSwitchChange() {
    this.switchLabel = this.nuevoCentroForm.controls['centActivado'].value ? 'Activado' : 'Desactivado';
  }
  salir(estado: any) {
    this.activeModal.close(estado);
  }
  validarAlfanumerico(event: Event, controlName: string): void {
    const input = event.target as HTMLInputElement;
    let valor = input.value;
    if (controlName === 'centSegmento' || controlName === 'centCentroCosto') {
        let valorValidado = valor.replace(/[^0-9]/g, '');
        if (valorValidado.length > 10) {
            valorValidado = valorValidado.substring(0, 10);
        }
        if (valor !== valorValidado) {
            input.value = valorValidado;
            this.nuevoCentroForm.controls[controlName].setValue(valorValidado);
        }
    } else if (controlName === 'centCodigoCompania') {
        let valorValidado = valor.replace(/[^a-zA-Z0-9_-]/g, '');
        if (valorValidado.length > 10) {
            valorValidado = valorValidado.substring(0, 10);
        }
        if (valor !== valorValidado) {
            input.value = valorValidado;
            this.nuevoCentroForm.controls[controlName].setValue(valorValidado);
        }
    } else if (controlName === 'centNombreCentro' || controlName === 'centAnalistaFinanzas') {
        let valorValidado = valor.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚ ]/g, '');
        if (valorValidado.length > 30) {
            valorValidado = valorValidado.substring(0, 30);
        }
        if (valor !== valorValidado) {
            input.value = valorValidado;
            this.nuevoCentroForm.controls[controlName].setValue(valorValidado);
        }
    } else if (controlName === 'centIniciales') {
        let valorValidado = valor.replace(/[^a-zA-Z0-9]/g, '');
        if (valorValidado.length > 4) {
            valorValidado = valorValidado.substring(0, 4);
        }
        if (valor !== valorValidado) {
            input.value = valorValidado;
            this.nuevoCentroForm.controls[controlName].setValue(valorValidado);
        }
    }
}

  obtenerSociedadesYSegmentos(): void {
    this._centrosService.listarSociedadesYSegmentos().subscribe({
      next: (data) => {
        console.log('Sociedades y segmentos:', data);
        this.sociedades = data;
        console.log('this.sociedades',this.sociedades)
      },
      error: (err) => {
        console.error('Error al obtener sociedades y segmentos:', err);
      }
    });
  }
  onSociedadChange(event: any): void {
    const sociedadSeleccionada = this.nuevoCentroForm.get('centSociedad')?.value;
    if (!sociedadSeleccionada) {
      this.segmentos = [];
      this.nuevoCentroForm.get('centSegmento')?.reset();
      this.sociedadSeleccionada = null;
      return;
    }
    this.sociedadSeleccionada = sociedadSeleccionada;

      console.log('Sociedad seleccionada:', this.sociedadSeleccionada);
      if (this.sociedadSeleccionada.segmentos) {
        this.nuevoCentroForm.get('centSegmento')?.enable();
        this.segmentos = this.sociedadSeleccionada.segmentos;
        if (this.segmentos.length === 1) {
          this.nuevoCentroForm.get('centSegmento')?.setValue(this.segmentos[0].seg_segmento);
          
        } else {
          this.nuevoCentroForm.get('centSegmento')?.reset();
          
          
        }
      }
      
    
  }
  
  
}

